<div class="row">
    <div class="col-md-12">
        <nav class="navbar navbar-expand-lg header-menu">
            <a class="navbar-brand" [routerLink]="[ '/']">
                <img src="assets/images/logo.png" alt="" style="width: 40%; height: 40%;">
                <img src="assets/images/logo_new.jpg" alt="" style="width: 60%; height: 40%;"></a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="mdi mdi-menu"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul class="navbar-nav"
                    style="font-size: 12pt; background-color: white; padding: 8px; border-radius: 10px; z-index: 1;">
                    <!-- <li class="nav-item">
                        <a class="nav-link header-text"
                            [routerLink]="[ '/calculate/initialinterest']" (click)="onClick()">การคำนวณดอกเบี้ยเงินกู้เบื้องต้น</a>
                    </li>
                    <li class="nav-item dropdown" style="cursor: pointer;">
                        <a class="nav-link header-text dropdown-toggle" id="dropdown" data-toggle="dropdown" (click)="onClick()"
                            aria-haspopup="true" aria-expanded="false">อื่นๆ</a>
                        <div class="dropdown-menu" aria-labelledby="dropdown">
                            <a class="nav-link header-text" [routerLink]="[ '/law']">กฎหมาย</a>
                            <a class="nav-link header-text" [routerLink]="[ '/manual']">คู่มือ</a>
                            <a class="nav-link header-text" [routerLink]="[ '/form']">แบบฟอร์ม</a>
                            <a class="nav-link header-text" [routerLink]="[ '/internaldata']">ข้อมูลภายในองค์กร</a>
                        </div>
                    </li> -->
                    <li class="nav-item dropdown" style="cursor: pointer;">
                        <a class="nav-link header-text dropdown-toggle" id="dropdown" data-toggle="dropdown"
                          aria-haspopup="true" aria-expanded="false" (click)="onClick()">บริหารงานทั่วไป</a>
                        <div class="dropdown-menu" aria-labelledby="dropdown">
                          <a class="nav-link header-text" href="https://ogc.mapedia.co.th/lrfund-general/#/">บริหารงานทั่วไป</a>
                          <a class="nav-link header-text" href="https://ogc.mapedia.co.th/lrfund-general/#/struc">โครงสร้างการบริหาร</a>
                          <a class="nav-link header-text" href="https://ogc.mapedia.co.th/lrfund-general/#/mission">ภารกิจ</a>
                          <a class="nav-link header-text" href="https://ogc.mapedia.co.th/lrfund-general/#/activity">ภาพกิจกรรม</a>
                        </div>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link header-text" (click)="onClick()"
                          [routerLink]="[ '/']">วิเคราะห์ติดตามและการลงทุน</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link header-text" (click)="onClick()"
                          [routerLink]="[ '/landingpage/initialinterest']">การคำนวณดอกเบี้ยเงินกู้เบื้องต้น</a>
                      </li>
                      <li class="nav-item dropdown" style="cursor: pointer;">
                        <a class="nav-link header-text dropdown-toggle" id="dropdown" data-toggle="dropdown"
                          aria-haspopup="true" aria-expanded="false" (click)="onClick()">เอกสารที่เผยแพร่</a>
                        <div class="dropdown-menu" aria-labelledby="dropdown">
                          <a class="nav-link header-text" [routerLink]="[ '/landingpage/law']">กฎหมายและระเบียบที่เกี่ยวข้อง</a>
                          <a class="nav-link header-text" [routerLink]="[ '/landingpage/manual']">คู่มือการปฏิบัติงาน</a>
                          <a class="nav-link header-text" [routerLink]="[ '/landingpage/form']">แบบฟอร์มต่าง ๆ</a>
                          <a class="nav-link header-text" [routerLink]="[ '/landingpage/internaldata']">ข้อมูลหน่วยงาน</a>
                        </div>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link header-text" (click)="onClick()"
                          href="https://ogc.mapedia.co.th/lrfund-general/#/contact">ติดต่อเรา</a>
                      </li>
                    <li class="nav-item">
                        <a class="nav-link header-text" [routerLink]="[ '/']" (click)="onClick()">เข้าสู่ระบบ</a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</div>